/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
export type paths = {
    readonly '/api/healthz': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Meta endpoint that returns 200 if server is ready */
        readonly get: operations['healthz']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/marketplace/app': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** "Fetch app information with given name from portal" */
        readonly get: operations['appDetails']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/marketplace/app/meta': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** "Fetch app meta information with given name from portal" */
        readonly get: operations['appDetailsMetadata']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/marketplace/apps': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** "List all available apps from portal according to the current Connectware license" */
        readonly get: operations['apps']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/agents': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Provides the system's agents for the running Connectware instance */
        readonly get: operations['systemAgents']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/health': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** "Endpoint to fetch health data of system container and later service container" */
        readonly get: operations['systemHealth']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/info': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Provides system information including features, license period and validity of the running Connectware instance
         *      */
        readonly get: operations['systemInfo']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/licensefile': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        /** Upload licensefile */
        readonly put: operations['systemLicenseFileUpload']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/metrics': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Provides system metrics for the running Connectware instance */
        readonly get: operations['systemMetrics']
        /** Trigger to send metrics to the portal */
        readonly put: operations['sendSystemMetrics']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/preflight': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Retrieve preflight information */
        readonly get: operations['systemPreflight']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/refresh': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** "Endpoint to trigger a refresh of the Connectware license file with the Cybus Portal" */
        readonly get: operations['systemRefresh']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/system/vrpcHealth': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** "Endpoint to fetch VRPC health data" */
        readonly get: operations['vrpcHealth']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
}
export type components = {
    schemas: {
        readonly File: {
            readonly availableInLicense: boolean
            readonly category: string
            readonly createdAt?: string
            readonly description: string
            readonly directory: string
            readonly filename: string
            readonly homepage: string
            readonly icon?: string
            readonly isTemplate: boolean
            readonly name: string
            readonly provider: string
            readonly publiclyOffered?: boolean
            readonly updatedAt: string
            readonly version: string
        }
        readonly FileDownload: {
            readonly contentType?: string
            readonly data?: string
            readonly filename?: string
            readonly size?: number
            readonly updatedAt?: string
            readonly version?: string
        }
        readonly ResourceReachability: {
            readonly status: boolean
            readonly statusText: string
            readonly url: string
        }
    }
    responses: never
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}

interface operations {
    readonly healthz: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly appDetails: {
        readonly parameters: {
            readonly query: {
                readonly directory: string
                readonly filename: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly data: string
                    }
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly appDetailsMetadata: {
        readonly parameters: {
            readonly query: {
                readonly directory: string
                readonly filename: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly content: {
                            readonly data: string
                        }
                        readonly meta: {
                            /** Format: date-time */
                            readonly updatedAt: string
                            readonly version: string
                        }
                    }
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly apps: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['File'][]
                }
            }
        }
    }
    readonly systemAgents: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly {
                        readonly classes: {
                            readonly [key: string]: {
                                readonly instances: readonly string[]
                            }
                        }
                        readonly hostname: string
                        readonly name: string
                        readonly version: string
                    }[]
                }
            }
            /** @description Not able to fetch system agents */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly systemHealth: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly system?: {
                            readonly status?: readonly {
                                readonly name?: string
                                readonly status?: string
                                readonly uptime?: string
                            }[]
                        }
                    }
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly systemInfo: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly license: {
                            readonly file?: {
                                readonly associatedAccount?: string
                                readonly connectwareLicenseClass?: string
                                /** Format: date */
                                readonly expiration?: string
                                readonly id?: string
                            }
                            readonly name?: string
                            readonly valid?: boolean
                        }
                        readonly time: string
                        readonly version: string
                    }
                }
            }
        }
    }
    readonly systemLicenseFileUpload: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description File contents */
                readonly 'application/json': {
                    readonly payload: string
                }
            }
        }
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly license?: {
                            readonly file?: Record<string, never>
                            readonly name?: string
                        }
                        readonly time?: string
                        readonly version?: string
                    }
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
        }
    }
    readonly systemMetrics: {
        readonly parameters: {
            readonly query?: {
                readonly daily?: boolean
                readonly hourly?: boolean
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly daily?:
                            | null
                            | readonly {
                                  readonly date: string
                                  readonly numberOfConnectedDatapoints: number
                                  readonly numberOfReceivedMessages: number
                              }[]
                        readonly hourly?:
                            | null
                            | readonly {
                                  readonly numberOfConnectedDatapoints: number
                                  readonly numberOfReceivedMessages: number
                                  /** Format: date */
                                  readonly timestamp: string
                              }[]
                    } | null
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly sendSystemMetrics: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly systemPreflight: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly currentVersions?: {
                            readonly series?: {
                                readonly active?: {
                                    readonly latest?: {
                                        readonly installerUrl: string
                                        readonly urlReleaseNotes: string
                                        readonly version: string
                                    }
                                }
                            }
                        }
                        readonly cybusPortal: components['schemas']['ResourceReachability']
                        readonly cybusRegistry: components['schemas']['ResourceReachability']
                        readonly dockerHub: components['schemas']['ResourceReachability']
                    }
                }
            }
        }
    }
    readonly systemRefresh: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly license?: {
                            readonly file?: Record<string, never>
                            readonly name?: string
                        }
                        readonly time?: string
                        readonly version?: string
                    }
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly [key: string]: unknown
                    }
                }
            }
        }
    }
    readonly vrpcHealth: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly agentStatus?: {
                            readonly agentName?: string
                            readonly status?: string
                        }
                        readonly VRPCInterServiceCommunication?: readonly {
                            readonly agentName?: string
                            readonly providers?: readonly {
                                readonly functionalityAffectedIfFailed?: readonly string[]
                                readonly providerName?: string
                                readonly reachable?: boolean
                            }[]
                        }[]
                    }
                }
            }
        }
    }
}

/** An auto-generated constant containing all paths */
export const pathsValue = [
    '/api/healthz' as const,
    '/api/marketplace/app' as const,
    '/api/marketplace/app/meta' as const,
    '/api/marketplace/apps' as const,
    '/api/system/agents' as const,
    '/api/system/health' as const,
    '/api/system/info' as const,
    '/api/system/licensefile' as const,
    '/api/system/metrics' as const,
    '/api/system/preflight' as const,
    '/api/system/refresh' as const,
    '/api/system/vrpcHealth' as const,
]
